export default "__VITE_ASSET__BXnnh6X4__"